import { openSubValuationModal } from '../../../../../State/subValuationModal'

export default (subValuation) => (dispatch) => {

  dispatch(openSubValuationModal({ subValuation }))

}
